import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";

export async function deletePurchaseAccount(accountId : string) {
    const response = await axios.delete<BaseResponse<boolean>>(`/purchase/account/${accountId}`)

    return response.data
}

